export default {"src":"/_next/static/media/one-round-of-revisions.277c473b.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};